import { api } from './api';

// News service. Two list endpoints:
//   - getNews        public, visibility-filtered server-side via the user's
//                    organisation -> groups chain
//   - getNewsAdmin   admin-only, returns drafts + expired entries too
export const newsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getNews: build.query({
      query: () => ({ url: 'news', method: 'GET' }),
      transformResponse: (r) => r.data || [],
      providesTags: (result) =>
        result
          ? [
            ...result.map((n) => ({ type: 'News', id: n.model.ID })),
            { type: 'News', id: 'LIST' },
          ]
          : [{ type: 'News', id: 'LIST' }],
    }),
    getNewsAdmin: build.query({
      query: () => ({ url: 'news/admin', method: 'GET' }),
      transformResponse: (r) => r.data || [],
      providesTags: [{ type: 'News', id: 'ADMIN_LIST' }],
    }),
    getNewsItem: build.query({
      query: (id) => ({ url: `news/${id}`, method: 'GET' }),
      transformResponse: (r) => r.data,
      providesTags: (_r, _e, id) => [{ type: 'News', id }],
    }),
    createNews: build.mutation({
      query: (body) => ({
        url: 'news',
        method: 'POST',
        body: JSON.stringify(body),
      }),
      invalidatesTags: [
        { type: 'News', id: 'LIST' },
        { type: 'News', id: 'ADMIN_LIST' },
      ],
    }),
    updateNews: build.mutation({
      query: ({ id, ...body }) => ({
        url: `news/${id}`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'News', id },
        { type: 'News', id: 'LIST' },
        { type: 'News', id: 'ADMIN_LIST' },
      ],
    }),
    deleteNews: build.mutation({
      query: (id) => ({ url: `news/${id}`, method: 'DELETE' }),
      invalidatesTags: [
        { type: 'News', id: 'LIST' },
        { type: 'News', id: 'ADMIN_LIST' },
      ],
    }),
  }),
});

export const {
  useGetNewsQuery,
  useGetNewsAdminQuery,
  useGetNewsItemQuery,
  useCreateNewsMutation,
  useUpdateNewsMutation,
  useDeleteNewsMutation,
} = newsApi;
